import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';

export default class consoleinLineStyleObj {

    constructor(data) {

        //this.log("topic Obj Model");
        //this.log(data);
        this.componentname = "styleObj";

        //New Data:
        this.id = data.id;
        this.subid = data.subid;
        this.subparentid = data.subparentid;
        this.partnerid = data.partnerid;
        this.stylecode = ko.observable(data.styleCode);
        this.elementname = data.elementName;
        this.sort = data.sort;
        this.standard = data.standard;
        this.createdate = data.createdate;

        this.getJdmStyle = ko.computed(function() {

            let htmlTag = this.elementname;

            switch(htmlTag)
            {
                case "body":
                htmlTag = "";
                break;
            }

            if(this.stylecode() == null){
                this.stylecode("");
            }

            
            if(this.stylecode().length > 3)
            {
                return ".fr-element.fr-view " + htmlTag + " " + this.stylecode() + "   ";
            }
            else
            {
                return "";
            }
            
        
        }, this);


        this.getCleanStyle = ko.computed(function() {
            
            let cleanStyle =  _.replace(this.stylecode(), /{/g, "");
            cleanStyle =  _.replace(cleanStyle, /}/g, "");

            if(this.stylecode().length > 3)
            {
                if(this.elementname != "@import")
                {
                    return this.elementname + ".jdm { " + cleanStyle + " } ";
                }
                else
                {
                    return this.elementname + " " + cleanStyle + "  ";
                }
                
            }
            else
            {
                return "";
            }
        
        }, this);

    }

}



// WEBPACK FOOTER //
// ./src/objects/editorStyleObj.js